import request from '../utils/request'
import global from '../config/global'

function get(id, params = {}) {
  return request({
    url: global.endpoint.WORKSPACE_MAIL_CONFIGURATION.replace(':id', id),
    method: 'get',
    params
  })
}

function update(id, data = {}) {
  return request({
    url: global.endpoint.WORKSPACE_MAIL_CONFIGURATION.replace(':id', id),
    method: 'put',
    data
  })
}

function remove(id) {
  return request({
    url: global.endpoint.WORKSPACE_MAIL_CONFIGURATION.replace(':id', id),
    method: 'delete',
  })
}

function send_test(id, data = {}) {
  return request({
    url: global.endpoint.WORKSPACE_MAIL_CONFIGURATION_TEST.replace(':id', id),
    method: 'post',
    data
  })
}

export default {
  get,
  update,
  remove,
  send_test
}
